import { getBeacon } from './beacon';
import { useAuth } from '@/store/auth';
import { Card, Coupon, PrivilegedStatus } from '@/entities/card';
import { query } from './util';

export const REPORT_TIMESTAMP = new Date().getTime();


export const getAid = (curProduct: Card, groupId = '') => {
  const fromid = query('fromid');
  const { qbid } = useAuth.storeInfo().accountInfo;
  const { qimei32, guid } = useAuth.storeInfo().deviceInfo;
  return `qbid:${qbid};ts:${REPORT_TIMESTAMP};qimei32:${qimei32};guid:${guid};goods_id:${curProduct?.goodsId};fromid:${fromid};groupId:${groupId}`;
};

// 0: 支付页面;
// 1: 权益中心页面曝光;
// 2: 帮助中心页面曝光;
// 3: 订单记录页面曝光;
// 4: 手机扫码支付页面;
// 5: 手机扫码协议弹窗;
export const pageModule = {
  Page: '0',
  rightsPage: '1',
  helpPage: '2',
  recordPage: '3',
  scanPage: '4',
  modal: '5',
};


/**
 * 1：支付按钮
 * 2：协议
 */
export const actModule = {
  proto: '1',
};

// 行为类型
export const actType = {
  click: 'ck',
  expose: 'ep',
  eventStart: 'st',
  eventEnd: 'ed',
};


// 0：发起支付
// 1：支付成功（后台仅上报1）
// 2：支付失败--支付取消
// 3：支付失败--网络/其他原因导致
export enum PayStatus {
  none = -1,
  ing = 0,
  succeed = 1,
  cancel = 2,
  fail = 3,
};


const buildUserInfo = () => {
  const accountInfo = useAuth.storeInfo().accountInfo;
  const deviceInfo = useAuth.storeInfo().deviceInfo;
  const { guid, qimei32, qimei36 } = deviceInfo;
  const { qbid, logintype, uin } = accountInfo;
  console.log('🚀 ~ file: report.ts:57 ~ buildUserInfo ~ deviceInfo:', deviceInfo);
  console.log('🚀 ~ file: report.ts:58 ~ buildUserInfo ~ accountInfo:', accountInfo);

  return {
    // @ts-ignore
    tguid: window?.external?.getFavSyncGuid?.() ?? '', // 88cb结尾那个guid
    // @ts-ignore
    machineid: window?.external?.getGuid?.() ?? '', // 老的guid,
    guid,
    qimei32,
    qimei36,
    qbid,
    user_num_type: logintype ?? '',
    user_num: uin ?? '',
    aid: getAid(goodInfo, couponInfo?.groupId ?? ''),
    web_version: '',
  };
};
const getQbUrl = () => {
  return window.location.href;
};

const buildBussinessInfo = () => {
  return {
    appid: query('appid'),
    sceneid: query('scene'),
    fromid: query('fromid'),
    url_link: getQbUrl(),
  };
};

const buildEventInfo = (pageModule?: any, actType?: any, actModule?: any) => {
  return {
    page_module: pageModule,
    act_type: actType,
    act_module: actModule || '',
  };
};

const buildProductInfo = (payStatus: PayStatus = -1) => {
  console.log('🚀 ~ buildProductInfo ~ goodInfo?.cardType:', goodInfo?.cardType);
  return {
    app_code: goodInfo?.serviceCode,
    midas_goods_id: goodInfo?.productId,
    goods_name: goodInfo?.serviceName,
    name: goodInfo?.name,
    goods_type: goodInfo?.cardType,
    pay_channel: 130,
    auto_pay: goodInfo?.autopayType,
    status: vipStatus,
    pay_status: payStatus,
    stock_id: couponInfo?.goodsId || '',
    midas_stock_id: couponInfo?.groupId || '',
    stock_type: couponInfo?.goodsId ? 1 : 0,
  };
};

let goodInfo: Card;
export const setGoodInfoReport = (selectGoodInfo: Card) => {
  goodInfo = selectGoodInfo;
};

let couponInfo: Coupon | undefined | null;
export const setCouponInfoReport = (selectCouponInfo: Coupon | undefined | null) => {
  couponInfo = selectCouponInfo;
};


let vipStatus: PrivilegedStatus | undefined;
export const setVipStatusReport = (curVipStatus: PrivilegedStatus | undefined) => {
  vipStatus = curVipStatus;
};

const reportKeyMap: any = {};

export const bsReport = (reqParams: any, payStatus?: PayStatus) => {
  const reportKey = `${reqParams?.pageModule || ''}-${reqParams?.actType || ''}-${reqParams?.actModule || ''}`;
  if (!reportKeyMap[reportKey] || reqParams.actType !== actType.expose) {
    getBeacon().report({
      ...buildUserInfo(),
      ...buildBussinessInfo(),
      ...buildEventInfo(reqParams.pageModule, reqParams.actType, reqParams.actModule),
      ...buildProductInfo(payStatus),
    });
    reportKeyMap[reportKey] = true;
  }
};

